const DataLayerTracking = () => {
    const primaryNavLinks = document.querySelectorAll('.primary-nav__link');
    const megaMenuLinks = document.querySelectorAll('.mega-menu .mega-menu__list-item .link');
    const secondaryNavLinks = document.querySelectorAll('.secondary-nav__link');
    const logoLink = document.querySelector('.header__logo');
    const flagListLinks = document.querySelectorAll('.flag-list__link');
    const footerNavLinks = document.querySelectorAll('.footer__top-link-list > li > a');
    const filterTables = document.querySelectorAll('.js-filters table');
    const productFilters = document.querySelectorAll('.js-product-filters');

    // Product category and subcategory are derived from the two last url segments,
    // e.g. /sv/produkter/rumsprodukter/luftburna-rumsprodukter/ => Rumsprodukter, Luftburna rumsprodukter
    const getCategoriesFromUrl = () => {
        const segments = window.location.pathname.split('/').filter(segment => segment !== '');
        const unslugify = (segment) => {
            const text = decodeURIComponent(segment).replace(/-/g, ' ').trim();
            return text.charAt(0).toUpperCase() + text.slice(1);
        };

        return {
            itemCategory: segments.length > 1 ? unslugify(segments[segments.length - 2]) : '',
            itemCategory2: segments.length > 0 ? unslugify(segments[segments.length - 1]) : ''
        };
    };

    const getFilterCategory = (checkbox) => {
        const accordion = checkbox.closest('.accordion');
        const accordionButton = accordion && accordion.querySelector('.accordion__button');

        if (!accordionButton) {
            return '';
        }

        // The button also holds a counter and an icon, so only the text nodes are used
        return [...accordionButton.childNodes]
            .filter(node => node.nodeType === Node.TEXT_NODE)
            .map(node => node.textContent.trim())
            .join(' ')
            .trim();
    };

    const getFilterValue = (checkbox) => {
        const label = checkbox.closest('.checkbox__label');
        const title = label && label.querySelector('.checkbox__title');

        return title ? title.textContent.trim() : (checkbox.getAttribute('data-text') || checkbox.value);
    };

    const init = () => {
        window.dataLayer = window.dataLayer || [];
        for (let i = 0; i < primaryNavLinks.length; i++) {
            const primaryNavLink = primaryNavLinks[i];
            if (primaryNavLink) {
                primaryNavLink.addEventListener('click', () => {
                    window.dataLayer.push({
                        event: 'main_menu_navigation',
                        main_category: primaryNavLink.textContent.trim()
                    });
                });
            }
        }

        for (let i = 0; i < megaMenuLinks.length; i++) {
            const megaMenuLink = megaMenuLinks[i];
            if (megaMenuLink) {
                megaMenuLink.addEventListener('click', () => {
                    const categoryList = megaMenuLink.closest('.mega-menu__list');
                    const megaMenuItem = megaMenuLink.closest('.mega-menu__item');
                    let subCategoryLink = null;
                    let mainCategoryLink = null;
                    if (megaMenuItem) {
                        mainCategoryLink = megaMenuItem.querySelector('.mega-menu__header');
                    }
                    if (categoryList) {
                        subCategoryLink = categoryList.firstElementChild;
                    }
                    window.dataLayer.push({
                        event: 'main_menu_navigation',
                        main_category: mainCategoryLink ? mainCategoryLink.textContent.trim() : '',
                        sub_category: subCategoryLink ? subCategoryLink.textContent.trim() : '',
                        content: megaMenuLink.textContent.trim()
                    });
                });
            }
        }

        for (let i = 0; i < secondaryNavLinks.length; i++) {
            const secondaryNavLink = secondaryNavLinks[i];
            if (secondaryNavLink) {
                secondaryNavLink.addEventListener('click', () => {
                    window.dataLayer.push({
                        event: 'main_menu_navigation',
                        content: secondaryNavLink.textContent.trim()
                    });
                });
            }
        }

        if (logoLink) {
            logoLink.addEventListener('click', () => {
                window.dataLayer.push({
                    event: 'logo_navigation'
                });
            });
        }

        for (let i = 0; i < flagListLinks.length; i++) {
            const flagListLink = flagListLinks[i];
            if (flagListLink) {
                flagListLink.addEventListener('click', () => {
                    window.dataLayer.push({
                        event: 'country_navigation',
                        country: flagListLink.textContent.trim()
                    });
                });
            }
        }

        for (let i = 0; i < footerNavLinks.length; i++) {
            const footerNavLink = footerNavLinks[i];
            if (footerNavLink) {
                footerNavLink.addEventListener('click', () => {
                    window.dataLayer.push({
                        event: 'footer_navigation',
                        main_category: footerNavLink.textContent.trim()
                    });
                });
            }
        }

        for (let i = 0; i < filterTables.length; i++) {
            const filterTable = filterTables[i];
            if (filterTable) {
                filterTable.addEventListener('click', (e) => {
                    if ((e.target.tagName === 'A' && e.target.classList.contains('js-document-tracking-link')) ||
                        (e.target.closest('a') && e.target.closest('a').classList.contains('js-document-tracking-link'))) {
                        const trackingRow = e.target.closest('tr.js-document-tracking-row');
                        const link = e.target.closest('a.js-document-tracking-link');

                        if (trackingRow && link) {
                            window.dataLayer.push({
                                event: 'file_download',
                                document_category: trackingRow.getAttribute('data-document-category'),
                                file_name: trackingRow.getAttribute('data-filename'),
                                file_extension: trackingRow.getAttribute('data-extension'),
                                click_type: link.textContent.trim() ? 'text' : 'download_button',
                                click_text: link.textContent.trim()
                            });
                        }
                    }
                });
            }
        }

        for (let i = 0; i < productFilters.length; i++) {
            const productFilter = productFilters[i];
            if (productFilter) {
                productFilter.addEventListener('change', (e) => {
                    const checkbox = e.target;

                    // Only user initiated selections, not filters restored from session storage
                    if (!e.isTrusted || !checkbox.matches('input[type="checkbox"]') || !checkbox.checked) {
                        return;
                    }

                    const { itemCategory, itemCategory2 } = getCategoriesFromUrl();

                    window.dataLayer.push({
                        event: 'select_filter',
                        item_category: itemCategory,
                        item_category2: itemCategory2,
                        filter_category: getFilterCategory(checkbox),
                        filter_value: getFilterValue(checkbox)
                    });
                });
            }
        }
    };

    init();
};

export default DataLayerTracking;
